import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { ILoggerMeasurement } from '@app/api/interfaces/logger-measurement.interface';
import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';

export const loggerMeasurementsKey = 'loggerMeasurements';

export const loggerMeasurementsAdapter = createEntityAdapter<ILoggerMeasurement>({
  selectId: loggerMeasurement => loggerMeasurement.id,
  sortComparer: false,
});

export interface ILoggerMeasurementsRequestState {
  projectId: string;
  areaId?: string;
  date?: string;
}

export interface ILoggerMeasurementsState extends EntityState<ILoggerMeasurement> {
  loaded: boolean;
  loading: boolean;
  triggerId: string | null;
  request: ILoggerMeasurementsRequestState | null;
  error: IApiBaseErrorResponse | null;
}

export const initialState: ILoggerMeasurementsState = loggerMeasurementsAdapter.getInitialState({
  loaded: false,
  loading: false,
  triggerId: null,
  request: null,
  error: null,
});
